import { render, staticRenderFns } from "./WatchLessons.vue?vue&type=template&id=193c5285&scoped=true&"
import script from "./WatchLessons.vue?vue&type=script&lang=js&"
export * from "./WatchLessons.vue?vue&type=script&lang=js&"
import style0 from "./WatchLessons.vue?vue&type=style&index=0&id=193c5285&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193c5285",
  null
  
)

export default component.exports